import React from 'react';
import Layout from '../../components/layout';
import Others from '../../components/one-oh-one/Others';

const headerText = 'SUBSTANCE USE 101';

const OneOhOne = () => {
  return (
    <Layout
      headerText={headerText}
      heroFont="has-text-white"
      heroBg="dark-hero"
    >
      <Others path="/one-oh-one/signs" />
    </Layout>
  );
};

export default OneOhOne;
